module.exports = __webpack_public_path__ + "img/rx-pc.6e2878ba.gif";